export default "__VITE_PUBLIC_ASSET__4d730fa4__"